/* Bouton Ajouter au panier de la fiche produit : meme envoi que le Quick add (JSON vers /cart/add.js), avec message d'erreur si le serveur refuse. */
(function () {
  if (window.__ithAtcFix) return;
  window.__ithAtcFix = true;

  var ERROR_MESSAGE = "L'ajout au panier n'a pas fonctionné. Merci de réessayer.";

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.closest) return;
    var el = form.closest('product-form');
    if (!el || el.form !== form) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();

    var btn = el.submitButton;
    if (btn.getAttribute('aria-disabled') === 'true') return;

    var spinner = el.querySelector('.loading__spinner');
    el.handleErrorMessage();
    btn.setAttribute('aria-disabled', true);
    btn.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');

    var fd = new FormData(form);
    var body = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 };
    var properties = {};
    fd.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    });
    if (el.hasAttribute('data-has-pre-order')) properties['Pre-order'] = '\u2713';
    if (Object.keys(properties).length) body.properties = properties;
    if (fd.get('selling_plan')) body.selling_plan = fd.get('selling_plan');

    if (el.cart) {
      body.sections = el.cart.getSectionsToRender().map(function (section) { return section.section; });
      body.sections_url = window.location.pathname;
      el.cart.setActiveElement(document.activeElement);
    }

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.text().then(function (text) {
          try {
            return JSON.parse(text);
          } catch (e) {
            throw new Error('Cart add refused: HTTP ' + response.status);
          }
        });
      })
      .then(function (response) {
        if (response.status) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: fd.get('id'),
              errors: response.errors || response.description,
              message: response.message
            });
          }
          el.handleErrorMessage(response.description || ERROR_MESSAGE);
          return;
        }
        if (!el.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: fd.get('id'),
            cartData: response
          });
        }
        el.error = false;
        el.cart.renderContents(response);
      })
      .catch(function (error) {
        console.error(error);
        el.handleErrorMessage(ERROR_MESSAGE);
      })
      .finally(function () {
        btn.classList.remove('loading');
        if (el.cart && el.cart.classList.contains('is-empty')) el.cart.classList.remove('is-empty');
        btn.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      });
  }, true);
})();
